export const demoExpert = {
  title1: "¿Necesita asesoría de un experto?",
  title2: "Hable con nuestros consultores en Transformación Digital",
  titleButton: "Consultar",
  urlButton:
    "https://outlook.office365.com/owa/calendar/ONLINE4BIZCOLSAS@ol4b.com/bookings/",
  img: "/pages/aboutUs/operador.svg",
}
